var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html, css } from "lit";
import { customElement, property } from "lit/decorators.js";
import iconCSS from "@/components/asset/uf-icon/icon.css";
let IconLSOnboarding = class IconLSOnboarding extends LitElement {
    constructor() {
        super(...arguments);
        this.theme = null;
    }
    render() {
        return html `
    <svg width="58" height="66" viewBox="0 0 58 66" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_2055_62519)">
      <path class="${this.theme}" d="M56.446 20.625H1.55403C1.14188 20.625 0.746603 20.462 0.455165 20.1718C0.163728 19.8816 0 19.488 0 19.0777L0 14.4375C0 12.7965 0.654718 11.2227 1.82012 10.0623C2.98553 8.9019 4.56615 8.25 6.21429 8.25H12.4286V1.54733C12.4286 1.13696 12.5923 0.743385 12.8837 0.453203C13.1752 0.163022 13.5704 0 13.9826 0H19.1621C19.5742 0 19.9695 0.163022 20.261 0.453203C20.5524 0.743385 20.7161 1.13696 20.7161 1.54733V8.25H37.2876V1.54733C37.2876 1.13727 37.451 0.74398 37.7421 0.453851C38.0331 0.163722 38.4279 0.000485854 38.8397 0L44.0192 0C44.2233 0 44.4254 0.040023 44.6139 0.117784C44.8025 0.195545 44.9738 0.30952 45.1181 0.453203C45.2624 0.596887 45.3769 0.767463 45.455 0.955194C45.5331 1.14293 45.5733 1.34413 45.5733 1.54733V8.25H51.7876C53.4354 8.25049 55.0155 8.9026 56.1805 10.0629C57.3455 11.2233 58 12.7968 58 14.4375V19.0777C58 19.2809 57.9598 19.4821 57.8817 19.6698C57.8036 19.8575 57.6891 20.0281 57.5448 20.1718C57.4005 20.3155 57.2292 20.4295 57.0407 20.5072C56.8521 20.585 56.65 20.625 56.446 20.625ZM1.55403 24.75H56.446C56.65 24.75 56.8521 24.79 57.0407 24.8678C57.2292 24.9455 57.4005 25.0595 57.5448 25.2032C57.6891 25.3469 57.8036 25.5175 57.8817 25.7052C57.9598 25.8929 58 26.0941 58 26.2973V59.8125C58 61.4535 57.3453 63.0273 56.1799 64.1877C55.0145 65.3481 53.4338 66 51.7857 66H6.21429C4.56615 66 2.98553 65.3481 1.82012 64.1877C0.654718 63.0273 0 61.4535 0 59.8125L0 26.2973C0 25.887 0.163728 25.4934 0.455165 25.2032C0.746603 24.913 1.14188 24.75 1.55403 24.75ZM44.7042 37.1177L41.0566 33.451C40.7652 33.1612 40.3702 32.9983 39.9583 32.9983C39.5464 32.9983 39.1514 33.1612 38.86 33.451L25.1315 47.0177L19.1787 41.0428C18.8873 40.753 18.4922 40.5902 18.0803 40.5902C17.6685 40.5902 17.2734 40.753 16.982 41.0428L13.2995 44.6747C13.0084 44.9648 12.8449 45.3581 12.8449 45.7683C12.8449 46.1784 13.0084 46.5717 13.2995 46.8618L23.9936 57.596C24.285 57.8858 24.68 58.0487 25.0919 58.0487C25.5038 58.0487 25.8988 57.8858 26.1902 57.596L44.6968 39.3158C44.9879 39.0257 45.1514 38.6324 45.1514 38.2222C45.1514 37.8121 44.9879 37.4188 44.6968 37.1287L44.7042 37.1177Z"/>
      </g>
      <defs>
      <clipPath id="clip0_2055_62519">
      <rect width="58" height="66" fill="white"/>
      </clipPath>
      </defs>
    </svg>
    `;
    }
};
IconLSOnboarding.styles = [iconCSS, css `
    path {
      fill: #FF284F;
    }

    path.orange {
      fill: #FB4F14;
    }

    path.yellow {
      fill: #FFC20E;
    }
  `];
__decorate([
    property()
], IconLSOnboarding.prototype, "theme", void 0);
IconLSOnboarding = __decorate([
    customElement("icon-ls-onboarding")
], IconLSOnboarding);
export { IconLSOnboarding };
